import React from 'react';
import propTypes from './propTypes';
import CropDefault from './CropDefault';

const OtherCrop = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <CropDefault
    className={className}
    notUseClass={notUseClass}
    style={style}
  />
);

OtherCrop.propTypes = propTypes;

export default OtherCrop;
